import { forwardRef, type Ref, type SVGProps } from "react";
const IconLeafOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.71 2.29a1 1 0 0 0-.89-.29c-.66.12-16.22 3-20.71 7.45A13.6 13.6 0 0 0 4 17.3a9.2 9.2 0 0 0 2.11 7.16l-3.82 3.83a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3.82-3.83a9.15 9.15 0 0 0 6 2.18A10 10 0 0 0 14.7 28a13.6 13.6 0 0 0 7.83-4.1C27 19.4 29.87 3.84 30 3.18a1 1 0 0 0-.29-.89m-8.6 20.18c-3.32 3.33-8.25 5.1-12.16 2l11.76-11.76a1 1 0 0 0-1.42-1.42L7.54 23A7.3 7.3 0 0 1 6 17.54a11.65 11.65 0 0 1 3.54-6.65c3.3-3.31 14.24-5.81 18.2-6.62-.82 3.96-3.32 14.89-6.63 18.2" />
  </svg>
);
const ForwardRef = forwardRef(IconLeafOutlineSVG);
ForwardRef.displayName = "IconLeafOutline";
export { ForwardRef as IconLeafOutline };
